export default __webpack_public_path__ + "static/media/truck_logo_dark.0d961857.png";